<template>
  <div class="aboutIndexClass">
    <div class="moonContent">
         <span class="titleClass">{{contentObj.title}}</span>
        <div class="contentClass">
            <div v-html="contentObj.content">
            </div>
            <div class="titleDivClass">
                <span class="titleSpanNameClass">联系方式</span>
                <span class="lineRightClass"></span>
            </div>
            <div>
                <span class="spanNameClass">邮箱</span>
                <span class="spanValueClass">lpdc@nao.cas.cn</span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name:'aboutIndex',
    data(){
        return{
            contentObj:{}
        }
    },
    mounted(){
        this.initDataFunc()
    },
    methods:{
        async initDataFunc(){
            let res = await this.$http.get(this.$const.moonSample.sampleAboutUS+`?pageNum=1&pageSize=10&type=2`);
			if (res && res.code==200) {
                if(res.data.length> 0){
                    res.data.forEach(element => {
                        if(element.title == '关于我们'){
                            this.contentObj = element
                        }
                    });
                }
			}
        }
    }

}
</script>

<style lang="scss" scoped>
.aboutIndexClass{
    width: 100%;
    text-align: center;
	background: #f0f5ff;
    .moonContent {
		width: 1200px;
		text-align: left;
		display: inline-block;
        background-color: #ffffff;
        border: 1px solid rgba(21, 65, 140, 0.2);
        border-radius: 4px;
        padding: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
        .titleClass{
            font-family: MicrosoftYaHeiUISemibold;
            font-size: 28px;
            color: #000000;
            letter-spacing: 0;
            font-weight: 600;
            height: 80px;
            line-height: 80px;
            display: block;
        }
        .contentClass{
            font-family: MicrosoftYaHeiUI;
            font-size: 18px;
            color: #333333;
            letter-spacing: 0;
            line-height: 38px;
            font-weight: 400;
        }

        .titleDivClass {
            display: flex;
            justify-content: left;
            align-items: center;
            height: 60px;
            .titleSpanNameClass {
                // width: 108px;
                height: 19px;
                font-family: ReeJi-BigRuixain, ReeJi-BigRuixain;
                font-weight: normal;
                font-size: 18px;
                color: #15418c;
                line-height: 19px;
                text-align: left;
                font-style: normal;
                font-weight: 600;
            }
            .lineRightClass {
                width: 88%;
                border-style: dashed;
                border-width: 1px;
                border-color: #abc0e3;
            }
        }
        .spanNameClass{
            background: rgba(21,65,140,0.08);
            width: 120px;
            height: 40px;
            display: inline-block;
            text-align: center;
        }
        .spanValueClass{
            font-family: MicrosoftYaHeiUISemibold;
            font-size: 16px;
            color: #15418C;
            letter-spacing: 0;
            margin-left: 10px;
            font-weight: 600;
        }
    }
}

</style>
